import { Injectable } from "@angular/core";
import { Usecase } from "../../../../domain/usecase/usecase.interface";
import { ResetPasswordDto } from "../../../../domain/dtos/reset-password.dto";
import { AuthRepository } from "../../../../domain/repositories/auth.repository";
import { Result } from "../../../../domain/models/http-response.model";

@Injectable({ providedIn: 'root' })
export class ResetPasswordUsecase implements Usecase<ResetPasswordDto, void> {
  constructor(private authRepository: AuthRepository) {}

  execute(resetPasswordData: ResetPasswordDto): Promise<Result<undefined, Error>> {
    return this.authRepository.resetPassword(resetPasswordData);
  }
}
